import { Button } from "components/DesignSystem/Button/Button";
import { LockedButton } from "components/DesignSystem/Button/LockedButton";
import { EditPencil } from "components/icons/EditPencil";
import { PlusIcon } from "components/icons/PlusIcon";
import { LockedUi } from "components/LockedUi/LockedUi";
import { WRITE_PERMISSION_KEYS } from "constants/permissions";

type SettingActionButtonProps = {
  isEdit: boolean;
  onClick: () => void;
};

export const SettingActionButton = ({
  isEdit,
  onClick,
}: SettingActionButtonProps) => {
  const label = isEdit ? "Edit" : "Add";
  const icon = isEdit ? (
    <EditPencil className="t-size-4" />
  ) : (
    <PlusIcon size="12" />
  );

  return (
    <LockedUi
      feature={WRITE_PERMISSION_KEYS.REVENUE}
      blockedUi={<LockedButton text={label} />}
    >
      <Button
        type="button"
        customType="secondary"
        size="small"
        leftIcon={icon}
        onClick={onClick}
      >
        {label}
      </Button>
    </LockedUi>
  );
};
